/*
 * ITALIANO — Avviso Proprietario / Copyright & IP Notice (Ultra-Restrittivo)
 *
 *   Copyright (c) 2026.
 *
 *   Copyright © 2026 PhepTech di Pietro Guglielmi. Tutti i diritti riservati.
 *   Copyright © 2026 Pietro Guglielmi. Tutti i diritti riservati.
 *
 *   1) Natura proprietaria – Nessuna licenza
 *
 *   Questo software e tutto il relativo materiale (inclusi, a titolo esemplificativo e
 *   non esaustivo: codice sorgente e/o oggetto, file, moduli, classi, funzioni, metodi,
 *   algoritmi, strutture dati, architettura, API, interfacce, UI/UX, testi, grafica,
 *   risorse, configurazioni, build logic, documentazione, specifiche e ogni derivato)
 *   sono opera protetta e/o contenuto proprietario di Pietro Guglielmi e/o PhepTech di
 *   Pietro Guglielmi (“Titolare”).
 *
 *   Nessuna licenza o diritto d’uso è concesso con la sola disponibilità, visione,
 *   accesso, download, clonazione, consegna o possesso del Software, salvo quanto
 *   espressamente autorizzato per iscritto dal Titolare tramite contratto o licenza
 *   separata firmata.
 *
 *   Sono esclusi tutti i diritti impliciti, inclusi (senza limitazione) diritti per
 *   implicazione, consuetudine, “estoppel” o altrimenti.
 *
 *   2) Divieti assoluti (salvo autorizzazione scritta)
 *
 *   È severamente vietato, in tutto o in parte, e con qualsiasi mezzo o finalità
 *   (inclusa finalità didattica, commerciale o concorrente), salvo esplicita
 *   autorizzazione scritta del Titolare:
 *
 *   - copiare, riprodurre, trascrivere, pubblicare, caricare, trasmettere, distribuire,
 *     ridistribuire, condividere, cedere, vendere, sublicenziare, noleggiare, prestare o
 *     rendere disponibile a terzi il Software;
 *
 *   - modificare, adattare, tradurre, trasformare, creare opere derivate, integrare o
 *     incorporare in altri prodotti/servizi, o utilizzare il Software per creare o
 *     addestrare modelli, dataset, automazioni o strumenti (inclusi sistemi di AI/ML)
 *     che ne replichino funzionalità o valore;
 *
 *   - effettuare reverse engineering, decompilare, disassemblare, decodificare o
 *     tentare di ricavare il sorgente, le chiavi, le logiche o i meccanismi interni;
 *     aggirare, disattivare o eludere misure di sicurezza/controllo accessi/DRM o
 *     meccanismi di protezione;
 *
 *   - rimuovere, alterare o occultare avvisi di copyright, marchi, attribuzioni,
 *     watermark o indicazioni di riservatezza.
 *
 *   Eccezione obbligatoria: quanto sopra vale nella massima misura consentita dalla
 *   legge applicabile; eventuali usi consentiti imperativamente dalla legge restano
 *   limitati allo stretto necessario.
 *
 *   3) Riservatezza e segreti commerciali (se applicabile)
 *
 *   Nella misura in cui il Software o parti di esso non siano stati resi pubblicamente
 *   disponibili dal Titolare, essi costituiscono Informazioni Riservate e possono
 *   integrare segreti commerciali.
 *
 *   È obbligatorio adottare misure di protezione almeno ragionevoli e comunque non
 *   inferiori a quelle usate per proteggere i propri segreti commerciali, e non
 *   divulgarli a terzi.
 *
 *   4) Titolarità, feedback e diritti IP
 *
 *   Il Software è di esclusiva titolarità del Titolare. Tutti i diritti di proprietà
 *   intellettuale e industriale (copyright, know-how, segreti commerciali, diritti su
 *   banche dati, marchi, brevetti — ove applicabili) restano del Titolare.
 *
 *   Qualsiasi idea, segnalazione, proposta di miglioramento o feedback comunicato al
 *   Titolare potrà essere utilizzato liberamente dal Titolare senza obbligo di
 *   compenso, attribuzione o restrizioni, nella misura consentita dalla legge.
 *
 *   5) Tutela e rimedi
 *
 *   Qualsiasi violazione può causare un danno grave e irreparabile. Il Titolare potrà
 *   richiedere inibitoria immediata, sequestro, rimozione dei contenuti, risarcimento
 *   danni, restituzione dei profitti e ogni ulteriore rimedio previsto dalla legge,
 *   incluse (ove consentite) spese legali.
 *
 *   6) Esclusione di garanzie e limitazione di responsabilità
 *
 *   Il Software è fornito “così com’è” e “come disponibile”, senza garanzie di alcun
 *   tipo, espresse o implicite, incluse (senza limitazione) garanzie di commerciabilità,
 *   idoneità a scopo particolare, non violazione, accuratezza o assenza di errori.
 *
 *   Nella massima misura consentita dalla legge, il Titolare non sarà responsabile per
 *   danni indiretti, incidentali, consequenziali, speciali, punitivi, perdita di
 *   profitti, dati o interruzione attività.
 *
 *   7) Legge applicabile e foro
 *
 *   Salvo norme inderogabili, il presente avviso e qualsiasi uso/non-uso del Software
 *   sono regolati dalla legge italiana. Ogni controversia è devoluta in via esclusiva
 *   al Foro di [MILANO] (sostituisci se preferisci altro foro).
 *
 *   8) Protezione internazionale
 *
 *   Il Software è protetto a livello internazionale secondo i principi di tutela
 *   automatica e “national treatment” previsti da convenzioni e accordi internazionali
 *   in materia di diritto d’autore e proprietà intellettuale (es. Convenzione di Berna,
 *   TRIPS), nei rispettivi Paesi aderenti.
 *
 *
 *   ENGLISH — Proprietary Notice / Copyright & IP Notice (Ultra-Restrictive)
 *
 *   Copyright (c) 2026.
 *
 *   Copyright © 2026 PhepTech di Pietro Guglielmi. All rights reserved.
 *   Copyright © 2026 Pietro Guglielmi. All rights reserved.
 *
 *   1) Proprietary nature – No license granted
 *
 *   This software and all related materials (including, without limitation: source
 *   and/or object code, files, modules, classes, functions, methods, algorithms, data
 *   structures, architecture, APIs, interfaces, UI/UX, text, graphics, assets,
 *   configurations, build logic, documentation, specifications, and any derivatives)
 *   are proprietary to Pietro Guglielmi and/or PhepTech di Pietro Guglielmi (“Owner”)
 *   and are protected by applicable intellectual property laws.
 *
 *   No license or right is granted by mere access, viewing, possession, delivery,
 *   download, cloning, or use of the Software, unless expressly authorized in writing
 *   by the Owner under a separate signed agreement/license.
 *
 *   All implied licenses are expressly disclaimed, including by implication, custom,
 *   estoppel, or otherwise.
 *
 *   2) Strict prohibitions (unless prior written permission)
 *
 *   You are strictly prohibited, in whole or in part, by any means and for any purpose
 *   (including educational, commercial, or competitive purposes), unless you have the
 *   Owner’s prior written permission, from:
 *
 *   - copying, reproducing, publishing, uploading, transmitting, distributing,
 *     re-distributing, sharing, selling, assigning, sublicensing, renting, leasing,
 *     lending, or otherwise making the Software available to any third party;
 *
 *   - modifying, adapting, translating, transforming, creating derivative works,
 *     integrating, incorporating into other products/services, or using the Software to
 *     build or train models, datasets, automations, or tools (including AI/ML systems)
 *     that replicate its functionality or value;
 *
 *   - reverse engineering, decompiling, disassembling, decoding, or attempting to
 *     derive source code, keys, logic, internal mechanisms; bypassing, disabling, or
 *     circumventing security/access controls/DRM or other protection measures;
 *
 *   - removing, altering, or obscuring copyright notices, trademarks, attributions,
 *     watermarks, or confidentiality markings.
 *
 *   Mandatory legal carve-out: the above applies to the maximum extent permitted by
 *   applicable law; any non-waivable statutory rights remain limited to what the law
 *   strictly requires.
 *
 *   3) Confidentiality & trade secrets (where applicable)
 *
 *   To the extent the Software (or any portion thereof) has not been publicly disclosed
 *   by the Owner, it constitutes Confidential Information and may include trade
 *   secrets. You must protect it using at least reasonable safeguards and must not
 *   disclose it to any third party.
 *
 *   4) Ownership, feedback, and IP rights
 *
 *   The Software is exclusively owned by the Owner. All intellectual and industrial
 *   property rights (copyright, know-how, trade secrets, database rights, trademarks,
 *   patents—where applicable) remain with the Owner.
 *
 *   Any ideas, suggestions, improvements, or feedback you provide may be used by the
 *   Owner without compensation, attribution, or restrictions, to the extent permitted
 *   by law.
 *
 *   5) Enforcement & remedies
 *
 *   Any violation may cause irreparable harm. The Owner may seek immediate injunctive
 *   relief, takedowns, seizure/impoundment where available, damages, disgorgement of
 *   profits, and any other remedies allowed by law, including attorneys’ fees where
 *   permitted.
 *
 *   6) Disclaimer of warranties & limitation of liability
 *
 *   The Software is provided “AS IS” and “AS AVAILABLE”, without warranties of any
 *   kind, express or implied, including merchantability, fitness for a particular
 *   purpose, non-infringement, accuracy, or error-free operation.
 *
 *   To the maximum extent permitted by law, the Owner shall not be liable for indirect,
 *   incidental, consequential, special, exemplary, or punitive damages, loss of profits
 *   or data, or business interruption.
 *
 *   7) Governing law & jurisdiction
 *
 *   Except where mandatory law provides otherwise, this notice and any use/non-use of
 *   the Software shall be governed by the laws of Italy, with exclusive jurisdiction in
 *   the courts of [MILAN] (edit as desired).
 *
 *   8) International protection
 *
 *   The Software is protected internationally under the principles of automatic
 *   protection and national treatment reflected in major international copyright/IP
 *   frameworks (e.g., the Berne Convention and TRIPS), in their respective member
 *   countries.
 */

package com.pheptech.kmp.newborn.demo5

import androidx.compose.runtime.Composable
import com.pheptech.kmp.newborn.demo5.domain.model.CommercialSlot
import com.pheptech.kmp.newborn.demo5.domain.model.PlanLevel
import com.pheptech.kmp.newborn.demo5.domain.model.getCapabilities
import com.pheptech.kmp.newborn.demo5.domain.repository.BusinessRepository
import com.pheptech.kmp.newborn.demo5.theme.AppStyles
import com.pheptech.kmp.newborn.demo5.theme.NewbornTheme
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
fun JoinPage(repository: BusinessRepository, onNav: (Screen, String?, String?, Screen?) -> Unit) {
    Div(attrs = { classes(AppStyles.container) }) {
        Section(attrs = { style { padding(4.cssRem, 0.px); textAlign("center") } }) {
            H2 { Text("Entra in NewBorn.com Corato") }
            P(attrs = {
                style {
                    fontSize(1.2.cssRem); color(NewbornTheme.textSecondary); maxWidth(800.px); property(
                    "margin",
                    "0 auto"
                ); marginBottom(3.cssRem)
                }
            }) {
                Text("La piattaforma che connette i migliori professionisti del settore con le famiglie di Corato. Scegli il piano più adatto alla tua attività.")
            }

            // Pricing Table
            Div(attrs = {
                style {
                    display(DisplayStyle.Flex); gap(2.cssRem); flexWrap(FlexWrap.Wrap); justifyContent(
                    JustifyContent.Center
                )
                }
            }) {
                PlanLevel.values().forEach { level ->
                    PricingCard(level) { onNav(Screen.BUSINESS_DASHBOARD, null, null, null) }
                }
            }

            Spacer(4.cssRem)

            // Commercial Slots
            H3 { Text("Aumenta la tua Visibilità") }
            P(attrs = { style { color(NewbornTheme.textSecondary); marginBottom(2.cssRem) } }) {
                Text("Acquista uno slot commerciale per apparire in cima alle ricerche e nelle sezioni dedicate.")
            }

            Div(attrs = {
                style {
                    display(DisplayStyle.Flex); gap(2.cssRem); flexWrap(FlexWrap.Wrap); justifyContent(
                    JustifyContent.Center
                )
                }
            }) {
                CommercialSlot.values().forEach { slot ->
                    SlotInfoCard(slot)
                }
            }
        }
    }
}

@Composable
fun PricingCard(level: PlanLevel, onClick: () -> Unit) {
    Div(attrs = {
        classes(AppStyles.card)
        style {
            flex(1); minWidth(280.px); maxWidth(350.px); padding(2.cssRem)
            if (level == PlanLevel.L3) border(2.px, LineStyle.Solid, NewbornTheme.primary) else border(
                1.px,
                LineStyle.Solid,
                NewbornTheme.border
            )
        }
    }) {
        if (level == PlanLevel.L3) {
            Span(attrs = {
                classes(AppStyles.badge); style {
                backgroundColor(NewbornTheme.primary); color(Color.white); alignSelf(
                AlignSelf.Center
            ); marginBottom(1.cssRem)
            }
            }) {
                Text("CONSIGLIATO")
            }
        }

        H4(attrs = { style { textAlign("center"); margin(0.px); fontSize(1.5.cssRem) } }) { Text(level.id) }

        Div(attrs = { style { textAlign("center"); padding(1.cssRem, 0.px) } }) {
            Span(attrs = { style { fontSize(2.5.cssRem); fontWeight(700); color(NewbornTheme.secondary) } }) { Text("${level.monthlyFee.toInt()}€") }
            Span(attrs = { style { color(NewbornTheme.textMuted) } }) { Text("/mese") }
        }

        Div(attrs = { style { textAlign("center"); marginBottom(1.5.cssRem) } }) {
            Text("Setup una tantum: ${level.setupFee.toInt()}€")
        }

        Ul(attrs = {
            style {
                padding(0.px); listStyle("none"); display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); gap(
                0.5.cssRem
            ); marginBottom(2.cssRem)
            }
        }) {
            CapabilityInfo(level)
        }

        Button(attrs = {
            classes(AppStyles.btn, if (level == PlanLevel.L3) AppStyles.btnPrimary else AppStyles.btnOutline)
            onClick { onClick() }
        }) {
            Text("Inizia ora")
        }
    }
}

@Composable
fun CapabilityInfo(level: PlanLevel) {
    level.getCapabilities()

    CapItem("Presenza in piattaforma", true)
    CapItem("Contatti e Indirizzo", true)
    CapItem("Link Sito Cliccabile", level != PlanLevel.L1)
    CapItem("Foto Vetrina", level == PlanLevel.L3)
    CapItem("Bottone WhatsApp", level == PlanLevel.L3)
    CapItem("Pubblicazione Promo", level == PlanLevel.L3)
    CapItem("Rating Stelline", level == PlanLevel.L3)
    CapItem("Mini-Analitiche Click", level == PlanLevel.L3)
}

@Composable
fun CapItem(label: String, included: Boolean) {
    Li(attrs = { style { display(DisplayStyle.Flex); alignItems(AlignItems.Center); gap(0.5.cssRem); color(if (included) NewbornTheme.textPrimary else NewbornTheme.textMuted) } }) {
        Text(if (included) "✓" else "✕")
        Text(label)
    }
}

@Composable
fun SlotInfoCard(slot: CommercialSlot) {
    Div(attrs = {
        classes(AppStyles.card)
        style { flex(1); minWidth(200.px); maxWidth(300.px); textAlign("center") }
    }) {
        H4 { Text(slot.label) }
        P(attrs = { style { fontSize(1.5.cssRem); fontWeight(700); color(NewbornTheme.primary) } }) { Text("${slot.price.toInt()}€/mese") }
        P(attrs = { style { fontSize(0.8.cssRem); color(NewbornTheme.textMuted) } }) {
            Text("Capacità: ${slot.capacity} attività")
        }
        if (slot == CommercialSlot.TRIAL) {
            P(attrs = { style { fontSize(0.8.cssRem); fontStyle("italic") } }) { Text("Massimo 1 mese per attività") }
        }
    }
}
